export function getToken() {
    return localStorage.getItem("token")
}

export function setToken(token) {
    return localStorage.setItem("token", token)
}

export function removeToken() {
    return localStorage.removeItem("token")
}

export function weixinLoginUrl() {
    //正式环境
    return 'https://gateway.letouros.com/center/ltUser/getMpCode?appid=wx7f47100180759027&redirect_uri=https%3A%2F%2Fcarinspection.letour.ltd%2Flogin'
    // return 'https://gateway.letouros.com/center/wxUser/getMpCode?appid=wx7f47100180759027&redirect_uri=https%3A%2F%2Fcarinspection.dljt.com.cn%2Flogin'

    //测试环境
    // return 'https://gateway.letouros.com/center/wxUser/getMpCode?appid=wx7f47100180759027&redirect_uri=http%3A%2F%2F127.0.0.1%3A8080%2Flogin'
    // return 'http://127.0.0.1:9999/center/wxUser/getMpCode?appid=wx7f47100180759027&redirect_uri=http%3A%2F%2F127.0.0.1%3A8080%2Flogin'
    // return 'https://test.letour.ltd/center/wxUser/getMpCode?appid=wx7f47100180759027&redirect_uri=http%3A%2F%2F192.168.4.136%3A8080%2Flogin'
}

export function baseApi() {
    // return 'https://carinspectionapi.dljt.com.cn'
    return 'https://carinspectionapi.letour.ltd'
    // return 'http://192.168.4.254:8013'
}
